import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, IsEmptyFilterOperatorComponent } from '@progress/kendo-angular-grid';
import { process, State, SortDescriptor } from '@progress/kendo-data-query';
import { AdminService } from '../../../../../core/services/admin.service';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { IErrorList, IAdminBannerImages, IAdminBannerImagesBody, ILanguages } from '../../../../../core/models/index';
import { Info } from '../../../../../core/common';
import { environment } from 'src/environments/environment';
import { SuccessEvent, SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { UserService } from '../../../../../core/services/user.service';

@Component({
  selector: 'app-homescreen-banner-admin',
  templateUrl: './homescreen-banner-admin.component.html',
  styleUrls: ['./homescreen-banner-admin.component.scss']
})
export class HomescreenBannerAdminComponent implements OnInit {

  //#region member & variable declaration
  imageGridLoading: boolean;
  imageGridView: GridDataResult;
  imageForm: FormGroup;
  saveInProcess: boolean;
  imageSrc: string;
  filePath: string;
  imageURL: string;
  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  languages: ILanguages[];
  selectedLanguageCode: string;
  public bannerImageUploadInvalid: boolean = false;
  bannerImageUpload: string = "";
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png", ".jfif"],
  };
  //#endregion
  constructor(private adminService: AdminService, private userService: UserService, private formBuilder: FormBuilder, private languageService: LanguageTranslationService
    , private appNotifyService: AppNotifyService,
  ) { }

  ngOnInit() {
    this.imageURL = environment.imageUrl;
    this.imageForm = this.formBuilder.group({
      imageId: new FormControl(0),
      componentName: new FormControl(""),
      urlPath: new FormControl(""),
      files: new FormControl(""),
      isActive: new FormControl(),
      imageDescription: new FormControl(""),
      imageType: new FormControl(""),
      language: new FormControl(""),
      displayOrder: new FormControl(0),
    });
    this.bindLanguages();
    this.loadImageGrid();

  }
  //#region kendo upload 
  imageAdminSelected(evt: SelectEvent) {
  }
  imageAdminUploadSuccess(evt: SuccessEvent) {
    this.bannerImageUpload = evt.response.body.paths[0];
  }
  //#endregion
  //#region label declaration
  public imageAdmin = {
    componentNameLbl: "Component Name",
    languageCodeLbl: "Language Code",
    imageTypeLbl: "Image Type",
    imageDescriptionLbl: "Description",
    urlPathLbl: "Image",
    isActiveLbl: "IsActive",
    displayOrderLbl: "Display Order",
    actionLbl: "Action",
    uploadLbl: "File Upload",
    isSubmitted: false,
    isEmptyFileUpload: false,
    isEmptyLanguage: false,
    isEmptyImageDescription: false,
    isEmptyImageDisplayOrder: false,
  }
  //#endregion
  //#region Grid data binding
  public loadImageGrid(): void {
    this.imageGridLoading = true;
    this.adminService.GetAdminBannerImages().subscribe((response) => {
      this.bindImageGrid();
      this.imageGridLoading = false;
    });
  }
  //#endregion

  //#region  bind language dropdown
  public bindLanguages(): void {
    this.languageService.getLanguages().subscribe((response) => {
      this.languages = response;
    });
  }
  //#endregion

  //#region pagination, sorting,filtering for grid
  public imageGridState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'imageId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindImageGrid(): void {
    const data = this.adminService.imageAdminBannerData;
    this.imageGridView = process(data, this.imageGridState);
  }

  public imageGridSortChange(sort: SortDescriptor[]): void {
    this.imageGridState.sort = sort;
    this.bindImageGrid();
  }
  public imageGridPageChange({ skip, take }: PageChangeEvent): void {
    this.imageGridState.skip = skip;
    this.imageGridState.take = take;
    this.bindImageGrid();
  }

  public imageDataStateChange(state: DataStateChangeEvent): void {
    this.imageGridState = state;
    this.bindImageGrid();
  }
  //#endregion

  //#region add image dialog operations
  editImageForm(data) {
    this.imageDialog.opened = !this.imageDialog.opened;
    //set form control value here
    this.imageForm.controls.componentName.setValue(data.componentName);
    this.imageForm.controls.imageType.setValue(data.imageType);
    this.imageForm.controls.imageDescription.setValue(data.imageDescription);
    this.imageForm.controls.urlPath.setValue(data.bannerImage);

    this.imageForm.controls.imageId.setValue(data.imageID);
    this.imageForm.controls.isActive.setValue(data.isActive);
    this.imageForm.controls.displayOrder.setValue(data.displayOrder);
    this.filePath = data.urlPath;
    this.bannerImageUpload = data.urlPath;
    this.selectedLanguageCode = data.languageCode;
    this.imageSrc = this.imageURL + data.urlPath;

  }
  imageDialog = {
    opened: false
  }
  toggleImageDialog() {
    this.imageDialog.opened = !this.imageDialog.opened;
    if (this.imageDialog.opened == false) {

    }
    else {
      //set isactive true here
      //this.imageForm.controls.isActive.setValue(true);
    }
    this.resetForm();



  }

  public validateForm(): boolean {
    let isValid = true;
    const controls = this.imageForm.controls;
    if (this.imageAdmin.isSubmitted) {

      if (controls.language.value.languageCode) {
        this.imageAdmin.isEmptyLanguage = false;
      } else {
        this.imageAdmin.isEmptyLanguage = true;
        isValid = false;
      }

      if (controls.imageDescription.value) {
        this.imageAdmin.isEmptyImageDescription = false;
      } else {
        this.imageAdmin.isEmptyImageDescription = true;
        isValid = false;
      }

      if (controls.displayOrder.value) {
        this.imageAdmin.isEmptyImageDisplayOrder = false;
      } else {
        this.imageAdmin.isEmptyImageDisplayOrder = true;
        isValid = false;
      }
      

      if (this.bannerImageUpload != undefined && this.bannerImageUpload != "") {
        this.bannerImageUploadInvalid = false;
      } else {
        this.bannerImageUploadInvalid = true;
        isValid = false;
      }
    }
    return isValid;
  }
  saveImageForm() {
    this.imageAdmin.isSubmitted = true;
    if (!this.validateForm()) {
      return;
    }

    this.initilizeSuccessLabel();
    this.saveInProcess = true;

    var controls = this.imageForm.controls;
    const body: IAdminBannerImagesBody = {
      imageId: controls.imageId.value == null || controls.imageId.value == undefined ? 0 : controls.imageId.value,
      componentName: controls.componentName.value,
      isActive: controls.isActive.value ? controls.isActive.value : false,
      urlPath: this.bannerImageUpload,
      applicationCode: "KD",
      imageDescription: controls.imageDescription.value,
      imageType: controls.imageType.value,
      languageCode: controls.language ? controls.language.value.languageCode.toString() : "",
      displayOrder: controls.displayOrder.value == null || controls.displayOrder.value == undefined ? 0 : controls.displayOrder.value,
      addedBy: this.userService.readUserObject.userName,
    }

    this.adminService.SaveAdminBannerImages(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        this.resetForm();
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        //this.bindImageGrid();
        this.loadImageGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }

    });

  }

  resetForm() {

    this.imageForm.reset();
    this.saveInProcess = false;
    this.infoMessage = new Info();

    this.imageAdmin.isSubmitted = false;
    this.imageAdmin.isEmptyFileUpload = false;
    this.imageAdmin.isEmptyLanguage = false,
      this.imageAdmin.isEmptyImageDescription = false,
      this.imageAdmin.isEmptyImageDisplayOrder = false,

    this.imageForm.controls.isActive.setValue(true);
    this.bannerImageUpload = "";
    this.filePath = "";
    this.imageSrc = "";
    this.selectedLanguageCode = '';
    this.imageForm.controls.componentName.setValue("Home");
    this.imageForm.controls.imageType.setValue("Banner");
  }
  //#endregion

  //#region save success label common code
  initilizeSuccessLabel() {
    this.inProgressMessage = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
  }

  //#endregion

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete Image ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  public RemoveHandler() {
    this.adminService.DeleteAdminBannerImages(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const imageId = this.gridItemToRemove.imageID;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected Image has been removed.");

      if (this.adminService.imageAdminBannerData) {
        //This is a Local Remove
        const index = (this.adminService.imageAdminBannerData).findIndex(r => r.imageId === imageId);
        (this.adminService.imageAdminBannerData).splice(index, 1);
        //this.bindImageGrid();
        this.loadImageGrid();
      }



    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion
}
